import dynamic, { LoadingComponentProps } from "next/dynamic";
import React, { ComponentType } from "react";
import { LoadingFormDelightful } from "./LoadingFormDelightful";

import { CountryCode } from "../../../../core/types";

interface NamedExport {
  WizardQuoteForm: ComponentType<any>;
}

const FormDefault = () => <></>;
const Loading: React.FC<LoadingComponentProps> = () => <LoadingFormDelightful />;

const dynOps = {
  loading: Loading,
  ssr: false
};

const getComponent = ({ WizardQuoteForm }: NamedExport) => WizardQuoteForm;

const forms = {
  [CountryCode.Brazil]: dynamic<ComponentType>(
    import("@comparaonline/ui-forms-brazil-next").then(getComponent),
    dynOps
  ),
  [CountryCode.Argentina]: FormDefault
};

const getDynamicWizardQuoteForm = (countryCode: CountryCode | string) => forms[countryCode];

export { getDynamicWizardQuoteForm, CountryCode };
